import { render, staticRenderFns } from "./UserAccessRightsTableItem.vue?vue&type=template&id=b66868fa&"
import script from "./UserAccessRightsTableItem.vue?vue&type=script&lang=ts&"
export * from "./UserAccessRightsTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports